var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8-tasks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.9 2h-23.8c-.6 0-1 .4-1 1v26c0 .6.4 1 1 1h23.8c.6 0 1-.4 1-1v-26c0-.6-.5-1-1-1zm-1 26h-21.8v-24h21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 9.9h7c.6 0 1-.4 1-1s-.4-1-1-1h-7c-.6 0-1 .4-1 1s.4 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 17h7c.6 0 1-.4 1-1s-.4-1-1-1h-7c-.6 0-1 .4-1 1s.4 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 24.1h7c.6 0 1-.4 1-1s-.4-1-1-1h-7c-.6 0-1 .4-1 1s.4 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2 25.7c.2.2.4.3.7.3.4 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-3.2 3.3-1.3-1.5c-.4-.4-1-.5-1.4-.1s-.5 1-.1 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2 18.6c.2.2.4.3.7.3.4 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-3.2 3.3-1.3-1.5c-.4-.4-1-.5-1.4-.1s-.5 1-.1 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2 11.6c.2.2.4.3.7.3.4 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-3.2 3.3-1.3-1.5c-.4-.4-1-.5-1.4-.1s-.5 1-.1 1.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.3bde3328951a030795d224e0418b719b.svg";
export { ForwardRef as ReactComponent };